/** =============
 *  animation should be dealt with closely native code
 * ===============
 */
// import $ from 'jquery'

let burgerBackGround: HTMLElement[] = []
let burgerMenu: HTMLElement
let burgerContainer: HTMLElement
let burgerIcon: HTMLElement

export const openBurger = () => {

  burgerContainer.style.display = 'block'
  requestAnimationFrame(() => {
    burgerBackGround.forEach(item => item.style.display = 'block')
    burgerMenu.style.transform = 'translateX(0)'
  });
}

export const findBurgerMenu = () => {

  if (!burgerIcon) {
    burgerIcon = document.getElementsByClassName('header-burger-icon')[0] as HTMLElement
  }

  const els = document.getElementsByClassName('header-burger-close');
  console.log(els.length)
  for (let i = 0; i < els.length; i++) {
    burgerBackGround.push(els[i] as HTMLElement)
  }

  if (!burgerMenu) {

    burgerMenu = document.getElementById('header-burger-menu-content') as HTMLElement
  }

  if (!burgerContainer) {
    burgerContainer = document.getElementById('header-burger-container') as HTMLElement
  }
}

export const closeBurger = () => {
  document.body.style.overflow = '';
  // burgerBackGround.style.display = 'none'
  burgerBackGround.forEach(item => item.style.display = 'none')
  burgerMenu.style.transform = 'translateX(100%)'
  setTimeout(() => {
    burgerContainer.style.display = 'none'
  }, 250)
}

export const initEvents = () => {

  // click on background to close burger
  burgerBackGround.forEach(item => item.addEventListener('click', function () {
    closeBurger()
    // unlock scroll body
    document.body.style.overflow = ''
  }))

  // click on icon to close burger
  burgerIcon.addEventListener('click', () => {
    openBurger()
    // lock scroll body
    document.body.style.overflow = 'hidden'
  })
}


const initBurger = () => {
  findBurgerMenu()
  initEvents()
}

export default initBurger